
import {
  defineComponent,
  ref,
  computed,
  useRouter,
  useRoute,
  onMounted,
  useFetch,
  useMeta,
} from '@nuxtjs/composition-api';
import { usePage, useAlternateLinks, useFetchDrivers } from '@/composables';

export default defineComponent({
  setup() {
    const { alternateLinks } = useAlternateLinks();
    const section = ref(null);
    const searchResultsSection = ref(null);
    const router = useRouter();
    const route = useRoute();
    const currentPage = computed(() => route.value.query.page);
    const searchQuery = computed(() => route.value.query.search);

    const { page, fetchPage } = usePage('drivers-and-manuals');
    const { products, fetchProducts, loading, pagesCount } = useFetchDrivers({
      searchQuery,
      currentPage,
    });

    useFetch(async () => {
      await fetchPage();
    });

    const search = (searchString) => {
      router.push({
        path: '/drivers-and-manuals/',
        query: { search: searchString || undefined },
      });
    };

    onMounted(() => {
      if (!searchQuery.value) return;
      fetchProducts();
    });

    useMeta(() => ({
      link: alternateLinks.value,
    }));

    return {
      search,
      section,
      searchResultsSection,
      searchQuery,
      products,
      pagesCount,
      loading,
      currentPage,
      page,
    };
  },
  head: {},
});
